export const auditor_cmpt_arr = [ {label: "Mosa de Manutenção", value: "0" },
    {label: "OJT", value: "1" },
    {label: "Mosa de Biblioteca Técnica", value: "2" },
    {label: "Mosa de CTM", value: "3" },
    {label: "Mosa de Engenharia", value: "4" },
    {label: "Mosa de Controle de Competências", value: "5" },
    {label: "Mosa de Almoxarifado", value: "6" },
    {label: "Mosa de Ferramentas", value: "7" },
    {label: "Mosa de GSE", value: "8" }];
